module.exports = __webpack_public_path__ + "static/media/404.8364ec21.jpg";